import { Injectable } from '@angular/core';
import { getApp } from '@angular/fire/app';
import { Messaging, getToken, isSupported, onMessage } from '@angular/fire/messaging';
import { getId, getInstallations } from 'firebase/installations';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ToastService } from '../toast/toast.service';


@Injectable({ providedIn: 'root' })

export class MessagingService {
    currentMessage = new BehaviorSubject<any>(null);
    private messageListenerSetup = false;
    constructor(private messaging: Messaging, private toast: ToastService) { }

    // Request permission + get FCM token
    async requestPermission() {
        try {

            if (!(await isSupported())) {
                console.error('FCM not supported');
                return;
            }
            console.log(environment.vapidKey);

            const swRegistration = await navigator.serviceWorker.ready;
            console.log('✅ SW ready:', swRegistration);

            try {

                const permission = await Notification.requestPermission();
                if (permission !== 'granted') {
                    console.error('❌ Notification permission denied');
                    this.toast.showToast('warning', 'Permission Denied', 'Notification permission is denied. Please allow or enable notifications to receive updates.');
                    return null;
                }
            } catch (error) {
                console.log("error in permisiion");
                this.toast.showToast('warning', 'Permission Denied', 'Notification permission is denied. Please allow or enable notifications to receive updates.');
                return null;
            }

            let token;
            try {
                token = await getToken(this.messaging, {
                    vapidKey: environment.vapidKey,
                    serviceWorkerRegistration: swRegistration
                });
                console.log('✅ FCM Token:', token);
            } catch (error) {
                console.log('Error FCM Token:', error);
                this.toast.showToast('warning', 'Permission Denied', 'Notification permission is denied. Please allow or enable notifications to receive updates.');
                return null;
            }



            // Get installation id
            const app = getApp();
            const installationId = await getId(getInstallations(app));
            console.log('🆔 Installation ID:', installationId);

            return { token, installationId };
        } catch (err) {
            console.error('Permission denied or error getting token', err);
            this.toast.showToast('warning', 'Permission Denied', 'Notification permission is denied. Please allow or enable notifications to receive updates.');
            // debugger;
            return err;
        }
    }

    async listen() {
        // Prevent multiple listeners
        if (this.messageListenerSetup) {
            console.log('⚠️ Message listener already set up');
            return;
        }

        console.log("Setting up message listener...");
        try {
            // Wait for service worker to be ready before setting up onMessage
            if ('serviceWorker' in navigator) {
                try {
                    const swRegistration = await navigator.serviceWorker.ready;
                    console.log('✅ SW ready for onMessage:', swRegistration);
                } catch (swError) {
                    console.warn('⚠️ Service worker not ready, continuing anyway:', swError);
                    // Continue even if service worker isn't ready - onMessage can still work
                }
            }

            // Set up foreground message handler
            // Note: onMessage works even without service worker being ready
            // It handles foreground messages when the app is open
            onMessage(this.messaging, (payload) => {
                console.log('📩 Foreground message received:', payload);
                this.currentMessage.next(payload);
            });

            this.messageListenerSetup = true;
            console.log('✅ Message listener set up successfully');
        } catch (error) {
            console.error('❌ Error setting up message listener:', error);
            this.messageListenerSetup = false;
            // Retry after a delay if setup failed
            setTimeout(() => {
                console.log('🔄 Retrying message listener setup...');
                this.listen();
            }, 3000);
        }
    }


    isNewMessageArrived(): Observable<any> {
        return this.currentMessage.asObservable();
    }

    setToEmpty(): void {
        this.currentMessage.next(null);
    }

    async refreshTokenIfNeeded() {
        const oldToken = localStorage.getItem('fcm_token');
        const newToken = await getToken(this.messaging, {
            vapidKey: environment.vapidKey,
        });

        if (newToken && newToken !== oldToken) {
            console.log('🔄 Token changed, updating...');
            localStorage.setItem('fcm_token', newToken);
            // Optionally call backend to re-register here
        } else {
            console.log('✅ Token still valid');
        }
    }

}
